<template>
  <div class="text-center online-users-box rounded-lg container">
            <v-img :src="BACKEND_LINK + $GLOBAL_DATA.user['profile_picture']" alt="profile_pic" width="100px" height="100px"
           class="rounded-circle mx-auto mt-5"></v-img>

        <div class="mt-2">{{ $GLOBAL_DATA['user']['get_full_name'] }}</div>
        <div class="row  mt-md-5">
          <div class="col-12">آخرین پرسنل آنلاین</div>
        </div>
    <div class="row rounded-pill my-2 mx-1 user-online" v-for="online_user in online_users_list">
      {{online_user['profile_picture']}}
            <v-col cols="4">
              <v-avatar>
                <v-img class="rounded-circle " max-width="50px" height="50px" :src="online_user['profile_picture_url']"></v-img>
              </v-avatar>
            </v-col>
            <v-col class="col">
              <div class="text-right">
                {{ `${online_user.first_name} ${online_user.last_name}` }}
              </div>
              <div class="text-left">
                <small style="color: rgba(0,0,0,0.6);">
                  {{ convert_en_to_fa_number(new Date(online_user.last_login).getMinutes() + ' : ' + new Date(online_user.last_login).getHours()) }}
                </small>
              </div>
            </v-col>
          </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OnlineUsers",
  data:()=>({
    key: localStorage.getItem('key'),
    online_users_list:null,
  }),
  created() {
    this.get_online_users();
  },
  methods:{
    get_online_users(){
      axios
          .get(this.BACKEND_LINK + '/api/account-admin/online-users/', {
            headers: {'Authorization': `Token ${this.key}`}
          })
          .then(response => (this.online_users_list = response.data))
          .catch(()=>{
            this.$snotify.error('خطا در دریافت کاربران آنلاین')
          });
      },


  }
}
</script>
